<template>
    <VJoyProductTour
        ref="productTourRef"
        icon="info-circle"
        open
        spotlight-selector="[data-product-tour-purchase-order]"
        position="left"
        data-testid="purchase-order-product-tour"
        :close-button="false"
    >
        <template #product-tour-header>{{ $t('projectclient.quote.view.quote-summary.dialog.purchase-order.title') }}</template>
        <template #product-tour-content>
            {{ $t('projectclient.quote.view.quote-summary.dialog.purchase-order.subtitle') }}
        </template>
        <template #product-tour-dismiss>
            <VJoyButton variant="ghost" size="small" data-testid="purchase-order-tour-add-later" @click="onAddLater">
                {{ $t('projectclient.quote.view.quote-summary.dialog.purchase-order.add-later') }}
            </VJoyButton>
        </template>
        <template #product-tour-next>
            <VJoyButton variant="main" size="small" data-testid="purchase-order-tour-add-now" @click="onAddNow">
                {{ $t('projectclient.quote.view.quote-summary.dialog.purchase-order.add-now') }}
            </VJoyButton>
        </template>
    </VJoyProductTour>
</template>

<script setup lang="ts">
    import {useTemplateRef} from 'vue';
    import {VJoyProductTour, VJoyButton} from '@maltjoy/core-vue';

    const productTourRef = useTemplateRef('productTourRef');

    const emit = defineEmits<{
        'add-later': [];
        'add-now': [];
    }>();

    function onAddLater() {
        productTourRef.value?.hide();
        emit('add-later');
    }

    function onAddNow() {
        productTourRef.value?.hide();
        emit('add-now');
    }
</script>
